module.exports = __webpack_public_path__ + "img/potion-love.385ae25e.svg";